import { HttpErrorResponse } from '@angular/common/http';
import { IBadInputFieldDetails } from '../models/system-internals/alert-dialog-contacts';
import { IProblemDetails, IValidationProblemDetails } from '../models/system-internals/http-errors';

export class ErrorMessageParserUtility {
    static buildHttpUserMessage(error: HttpErrorResponse): string | IBadInputFieldDetails[] {
        if (!error) {
            return 'The request failed. Please try again.';
        }

        if (error.status === 0) {
            return 'Unable to reach the server. Please check your network connection and try again.';
        }

        if (error.status >= 500) {
            return 'The server encountered an error. Please try again later.';
        }

        if (error.status === 404) {
            return 'Requested resource was not found.';
        }

        if (error.status === 401 || error.status === 403) {
            return 'You are not authorized to perform this action.';
        }

        if (error.status === 400) {
            const apiMessage = ErrorMessageParserUtility.extractApiMessage(error);
            return apiMessage ?? 'The request could not be processed. Please review the entered data and try again.';
        }

        return error.message || 'The request failed. Please try again.';
    }

    static extractApiMessage(error: HttpErrorResponse): string | IBadInputFieldDetails[] | undefined {
        if (!error) {
            return undefined;
        }

        if (typeof error.error === 'string') {
            return error.error;
        }

        if (error.error && typeof error.error === 'object') {
            if ('message' in error.error && typeof error.error.message === 'string') {
                return error.error.message;
            }

            if ('title' in error.error && typeof error.error.title === 'string') {
                return this.parseBadRequestMessage(error);
            }
        }

        return undefined;
    }

    static parseBadRequestMessage(originalError: any): IBadInputFieldDetails[] | undefined {

        //TODO: CAST THE OBJECT TO SPECIFIC TYPE AND SHOW DETAILED ERROR MESSAGE
        let errorMessage: string = "Failed to save data";
        const badRequestError = originalError.error as IProblemDetails;

        // console.log(originalError);
        if (badRequestError) {
            if (badRequestError.title) {
                errorMessage = badRequestError.title;
                const validationError = originalError.error as IValidationProblemDetails;
                if (validationError) {
                    const listCustomErrorMessage: IBadInputFieldDetails[] = [];
                    let errorList = validationError.errors;
                    for (let errorFieldName in errorList) {
                        // errorMessage = errorMessage + "\n" + "Field : " + errorFieldName+"\n";
                        let fieldErrorList = errorList[errorFieldName];
                        //let fieldError = fieldErrorList[0];
                        for (let fieldError in fieldErrorList) {
                            // errorMessage = errorMessage + fieldErrorList[fieldError] + ".\n"; 
                            listCustomErrorMessage.push({ fieldName: errorFieldName, description: fieldErrorList[fieldError] })
                            //TODO: Add detailed error message here
                        }
                    }
                    return listCustomErrorMessage;
                }
            }
        }
        return undefined;
    }
}
